const toolsData = [
	{
		slug: 'odds-converter',
		title: 'Odds Converter',
		description: 'Convert between American, Decimal, and Fractional odds formats instantly. Essential for comparing lines across different sportsbooks.',
		icon: 'SwapHoriz',
		metaTitle: 'Odds Converter Calculator - American, Decimal & Fractional | WagerWiz',
		metaDescription: 'Free odds converter tool. Instantly convert between American (+150), Decimal (2.50), and Fractional (3/2) odds formats. Compare lines across sportsbooks easily.',
		faqs: [
			{ q: 'How do I convert American odds to decimal?', a: 'For positive American odds, divide by 100 and add 1. For negative odds, divide 100 by the absolute value and add 1. For example, +150 = 2.50 decimal, -200 = 1.50 decimal.' },
			{ q: 'What are fractional odds?', a: 'Fractional odds show the profit relative to your stake. 3/2 means you win $3 for every $2 wagered, plus your stake back. They are most commonly used in UK betting markets.' },
		],
	},
	{
		slug: 'devig-calculator',
		title: 'Devig Calculator',
		description: 'Remove the vig from sportsbook odds to find true probabilities. Supports multiplicative, additive, power, and Shin devigging methods.',
		icon: 'FilterAlt',
		metaTitle: 'Devig Calculator - Remove the Vig & Find True Odds | WagerWiz',
		metaDescription: 'Free devig calculator. Remove sportsbook vig using multiplicative, additive, power, or Shin methods. Find true probabilities and fair no-vig odds.',
		faqs: [
			{ q: 'What does devigging mean?', a: 'Devigging (or de-vigging) means removing the built-in sportsbook margin (vig/juice) from odds to estimate the true probability of an outcome. This helps identify +EV betting opportunities.' },
			{ q: 'Which devig method is best?', a: 'The power method and Shin method are generally considered the most accurate for most markets. The multiplicative method is the simplest and works well for balanced markets.' },
		],
	},
	{
		slug: 'ev-calculator',
		title: 'EV Calculator',
		description: 'Calculate the expected value of any bet. Determine if a wager has a positive edge based on your odds and the true probability.',
		icon: 'TrendingUp',
		metaTitle: 'Expected Value (EV) Calculator - Calculate Betting Edge | WagerWiz',
		metaDescription: 'Free EV calculator for sports betting. Calculate expected value from your odds and true probability. Find +EV bets and measure your betting edge.',
		faqs: [
			{ q: 'What is expected value in sports betting?', a: 'Expected value (EV) is the average amount you expect to win or lose per bet over time. A positive EV (+EV) means the bet is profitable long-term, while negative EV (-EV) means you\'ll lose money over time.' },
			{ q: 'How do I calculate EV?', a: 'EV = (Win Probability × Profit if Win) - (Loss Probability × Stake). If EV is positive, the bet has a mathematical edge in your favor.' },
		],
	},
	{
		slug: 'kelly-criterion-calculator',
		title: 'Kelly Criterion Calculator',
		description: 'Calculate optimal bet sizing using the Kelly Criterion formula. Maximize long-term bankroll growth with full and fractional Kelly stakes.',
		icon: 'AccountBalance',
		metaTitle: 'Kelly Criterion Calculator - Optimal Bet Sizing | WagerWiz',
		metaDescription: 'Free Kelly Criterion calculator. Find your optimal bet size based on edge and odds. Includes full Kelly, half Kelly, and quarter Kelly recommendations.',
		faqs: [
			{ q: 'What is the Kelly Criterion?', a: 'The Kelly Criterion is a mathematical formula that determines the optimal percentage of your bankroll to wager on a bet with a positive edge. It maximizes long-term growth while minimizing the risk of ruin.' },
			{ q: 'Should I use full Kelly or fractional Kelly?', a: 'Most professional bettors use fractional Kelly (typically quarter or half Kelly) to reduce variance and the risk of large drawdowns. Full Kelly is mathematically optimal but very aggressive.' },
		],
	},
	{
		slug: 'parlay-calculator',
		title: 'Parlay Calculator',
		description: 'Calculate combined odds, payouts, and implied probability for multi-leg parlays. Add or remove legs dynamically.',
		icon: 'Link',
		metaTitle: 'Parlay Calculator - Combined Odds & Payout Calculator | WagerWiz',
		metaDescription: 'Free parlay calculator. Calculate combined odds, total payout, and implied probability for multi-leg parlays. Add unlimited legs with American odds.',
		faqs: [
			{ q: 'How are parlay odds calculated?', a: 'Parlay odds are calculated by converting each leg to decimal odds, multiplying them together, then converting back. Each leg must win for the parlay to pay out.' },
			{ q: 'Are parlays a good bet?', a: 'Parlays generally have a higher house edge than straight bets because the vig compounds with each leg. However, correlated parlays or +EV parlays can still offer value.' },
		],
	},
	{
		slug: 'arbitrage-calculator',
		title: 'Arbitrage Calculator',
		description: 'Detect arbitrage opportunities and calculate optimal stake allocation across sportsbooks for guaranteed profit.',
		icon: 'Balance',
		metaTitle: 'Arbitrage Calculator - Find Risk-Free Betting Profits | WagerWiz',
		metaDescription: 'Free arbitrage betting calculator. Detect arb opportunities, calculate optimal stake allocation, and find guaranteed profit across sportsbooks.',
		faqs: [
			{ q: 'What is arbitrage betting?', a: 'Arbitrage betting (arbing) exploits price differences between sportsbooks by betting on all outcomes of an event. When the combined implied probabilities are below 100%, you can guarantee a profit regardless of the outcome.' },
			{ q: 'How much profit can you make from arbitrage?', a: 'Typical arbitrage opportunities yield 1-5% profit per event. While individual returns are small, they are risk-free and compound over time with consistent volume.' },
		],
	},
	{
		slug: 'hold-calculator',
		title: 'Hold/Vig Calculator',
		description: 'Calculate the sportsbook hold (vig/margin) on any market. See implied probabilities and the overround percentage.',
		icon: 'Percent',
		metaTitle: 'Hold/Vig Calculator - Calculate Sportsbook Margin | WagerWiz',
		metaDescription: 'Free hold/vig calculator. Calculate sportsbook margin, implied probabilities, and overround percentage for any two-way market.',
		faqs: [
			{ q: 'What is the hold or vig?', a: 'The hold (also called vig, juice, or margin) is the sportsbook\'s built-in profit margin. It\'s the difference between the true probability and the implied probability from the odds. A standard NFL spread has about 4.5% hold.' },
			{ q: 'How is hold calculated?', a: 'Hold = (Implied Probability of Side A + Implied Probability of Side B) - 100%. For example, if both sides are -110, each implies 52.38%, so the hold is 4.76%.' },
		],
	},
	{
		slug: 'implied-probability-calculator',
		title: 'Implied Probability Calculator',
		description: 'Convert betting odds in any format to implied probability percentage and breakeven win rate.',
		icon: 'PieChart',
		metaTitle: 'Implied Probability Calculator - Odds to Probability | WagerWiz',
		metaDescription: 'Free implied probability calculator. Convert American, Decimal, or Fractional odds to implied probability percentage and breakeven win rate.',
		faqs: [
			{ q: 'What is implied probability?', a: 'Implied probability is the win percentage suggested by the betting odds. It represents how often you need to win at those odds to break even, including the sportsbook\'s vig.' },
			{ q: 'How do I convert American odds to probability?', a: 'For negative odds: Probability = |Odds| / (|Odds| + 100). For positive odds: Probability = 100 / (Odds + 100). For example, -150 implies 60% and +150 implies 40%.' },
		],
	},
	{
		slug: 'hedge-calculator',
		title: 'Hedge Bet Calculator',
		description: 'Calculate the optimal hedge stake to guarantee profit or minimize risk on an existing bet. See payouts for both outcomes.',
		icon: 'Shield',
		metaTitle: 'Hedge Bet Calculator - Lock In Guaranteed Profit | WagerWiz',
		metaDescription: 'Free hedge bet calculator. Calculate optimal hedge stake for guaranteed profit. See exact payouts for both outcomes and lock in risk-free returns.',
		faqs: [
			{ q: 'What is hedging a bet?', a: 'Hedging means placing a second bet on the opposite outcome to reduce risk or lock in a guaranteed profit. It\'s commonly used when your original bet is close to winning, like the final leg of a parlay.' },
			{ q: 'When should I hedge a bet?', a: 'Consider hedging when the potential payout is significant relative to your bankroll, or when locking in a guaranteed profit outweighs the expected value of letting the bet ride.' },
		],
	},
];

export default toolsData;
